import TrainerActivities from 'src/refactor_components/trainer/trainer-activities';
import TrainerBadge from 'src/refactor_components/trainer/trainer-badge';
import TrainerLecture from 'src/refactor_components/trainer/trainer-lecture';
import TrainerIntro from 'src/refactor_components/trainer/trainer-intro';
import TrainerQualification from 'src/refactor_components/trainer/trainer-qualification';
import TrainerSchedule from 'src/refactor_components/trainer/trainer-schedule';
import TrainerLocation from 'src/refactor_components/trainer/trainer-location';
import RowContent from 'src/refactor_shared/ui/row-content';
import EmptyContent from 'src/refactor_shared/ui/empty-content';

const TrainerHome = ({
  data,
  lecturesData,
  informationQuestion,
  qnaQuestions,
  portfolio
}: {
  data: any;
  lecturesData: any;
  informationQuestion: any;
  qnaQuestions: any;
  portfolio: any;
}) => {
  const noContentForQualification =
    data?.degree?.name ||
    data?.career?.name ||
    data?.license?.name ||
    data?.award?.name ||
    data?.education?.name;
  return (
    <div className="px-20 py-40 flex flex-col gap-60 w-full">
      <TrainerBadge badge={[]} />
      <TrainerIntro
        shortIntroduction={data.account.shortIntroduction}
        introduction={data.account.introduction}
      />
      <TrainerQualification data={data.qualifications} title="정보">
        {noContentForQualification ? (
          <>
            <RowContent
              title="학력"
              content={data.degree.name}
              totalCounts={data.degree.count}
            />
            <RowContent
              title="경력"
              content={data.career.name}
              totalCounts={data.career.count}
            />
            <RowContent
              title="자격"
              content={data.license.name}
              totalCounts={data.license.count}
            />
            <RowContent
              title="수상"
              content={data.award.name}
              totalCounts={data.award.count}
            />
            <RowContent
              title="교육"
              content={data.education.name}
              totalCounts={data.education.count}
            />
            <TrainerQualification.More />
          </>
        ) : (
          <EmptyContent>정보가 없습니다</EmptyContent>
        )}
      </TrainerQualification>
      <TrainerActivities name={data.name}>
        {/* <TrainerActivities.port clinicalDataList={portfolio} /> */}
        <TrainerActivities.info data={informationQuestion} />
        <TrainerActivities.qna data={qnaQuestions} />
      </TrainerActivities>
      <TrainerLecture lecturesData={lecturesData} />
      <TrainerSchedule data={data?.schedules} />
      <TrainerLocation recommendGyms={data.gyms} />
    </div>
  );
};

export default TrainerHome;
